module.exports = __webpack_public_path__ + "img/web-land-1.40c7f55f.png";